module.exports = {
  BackToMain: 'Вернуться на главный экран',
  UserInfo: 'Личная информация',
  Individual: 'Персонализация страницы',
  Cache: 'Кэш',
  Authorize: 'Авторизация',
  CNName: 'Имя на китайском:',
  Phone: 'Мобильный телефон:',
  ENName: 'Имя на английском:',
  Tel: 'Телефон:',
  Email: 'Электронная почта:',
  QQ: 'QQ:',
  MyInfo: 'Личные данные',
  PersonalEmailSettings: 'Настройки личной почты',
  EmailPassword: 'Пароль почты/код авторизации:',
  SignatureSetup: 'Настройка подписи',
  ToEnableTheSignature: 'Включить подпись',
  SendTest: 'Отправить тест',
  Edit: 'Редактировать',
  Save: 'Сохранить',
  Cancel: 'Отмена',
  ChangePsd: 'Изменить пароль',
  ErrorRaised: 'Произошла ошибка.',
  SaveSucceed: 'Сохранение успешно.',
  ResetJobCopySucceed: 'Теперь можно снова настроить условия копирования страницы',
  CancelChange: 'Вы уверены, что хотите отменить текущие изменения?',
  Name: 'Название',
  company: 'Компания',
  platformId: 'ID платформы',
  department: 'Отдел',
  Version: 'Версия',
  Amount: 'Всего',
  Filter: 'Поиск:',
  RefreshCache: 'Обновить кэш',
  ResetCache: 'Сбросить кэш',
  Refresh: 'Обновить',
  Reset: 'Сбросить',
  Detail: 'Просмотреть',
  UserName: 'ФИО',
  LoginTime: 'Время входа',
  ExitTime: 'Последнее действие',
  BackToMyAccount: 'Выйти из авторизованного аккаунта',
  AuthHistory: 'История использования авторизации',
  User: 'Пользователь',
  NewAuth: 'Авторизация',
  BeginDate: 'Дата начала',
  EndDate: 'Дата окончания',
  CancalAuth: 'Отозвать авторизацию',
  UseAuth: 'Использовать авторизацию',
  AuthOwned: 'Текущие доступные авторизации',
  AuthFail: 'Ошибка авторизации',
  ConfirmAuth: 'Подтвердить авторизацию',
  InputAuthReason: 'Введите причину авторизации',
  AdminUse: 'Вход администратора:',
  InvalidUser: 'Пожалуйста, введите правильного пользователя и дату!',
  AuthMyself: 'Нельзя авторизовать себя!',
  InputUser: 'Введите имя пользователя для авторизации!',
  Tips: 'Подсказка',
  SaveYourChange: 'Имеются несохраненные изменения. Закройте все открытые модули перед выходом из авторизованной учетной записи!',
  ShutModule: 'Перед выходом из авторизованной учетной записи закройте открытые модули. В настоящее время открыто {0} модулей. Закрыть все?',
  LoginMySelf: 'Не нужно повторно входить в свой аккаунт!',
  SelectAccout: 'Введите аккаунт, в который хотите войти!',
  TableColor: 'Цвет таблицы',
  StatusName: 'Название статуса',
  ColorValue: 'Значение цвета',
  PartnerDisplayControl: 'Управление отображением данных',
  PartnerCategory: 'Категория данных',
  Chinese: 'Китайский',
  English: 'Английский',
  Code: 'Код',
  EnglishAndChinese: 'Английский + китайский',
  ChineseAndEnglish: 'Китайский + английский',
  ShortName: 'Сокращение',
  CodeAndChinese: 'Код + китайский',
  CodeAndEnglish: 'Код + английский',
  ShortNameAndChinese: 'Сокращение + китайский',
  YouDoNotHaveAccessToTheAdministratorAccount: 'У вас нет доступа к учетной записи администратора',
  Setting: 'Нст.',
  VerificationSettings: 'Настройки попапа проверки',
  ResetJobCopyTittle: 'Сбросить условия страницы',
  ResetJobCopyMessage: 'После нажатия кнопки "Настройки" при копировании снова отобразится диалоговое окно настройки условий копирования, где можно сбросить параметры',
  RepeatCopyMessage: 'Уже существует расход с таким названием. Записать снова?',
  WeChatPushRemindTitle: 'Отсканируйте QR-код ниже и подпишитесь на официальный аккаунт "WallTech Информация о Volbank"',
  WeChatPushRemind1: 'Убедитесь, что вы подписаны на "WallTech Информация о Volbank", иначе не сможете получать сообщения WeChat.',
  WeChatPushRemind2: 'Сообщения WeChat могут приходить с задержкой. Актуальная информация отображается на веб-странице.',
  IveFollowed: 'Я подписался',
  CheckedCategory: 'Категория флажков',
  AfterCheckedSelection: 'После нажатия кнопки "Сброс" при оформлении страховки снова откроется страница выбора агента, где можно сбросить настройки',
  FreightInsuranceProvider: 'Поставщик услуг грузового страхования',
  ResetFreightInsuranceProvider: 'Сбросить поставщика грузового страхования',
  FreightInsuranceProviderReset: 'Настройки поставщика грузового страхования сброшены',
  CopyBusiness: 'Копирование операции',
  UseSsl: 'Включить режим SSL',
  Japanese: 'Японский',
  CustomerSupplierNoChinese: 'Код клиента/поставщика + китайский',
  threeCharacterCode: 'Сокращение + трехбуквенный код',
  threeCharacterCodeTooltip: 'Трехбуквенный код: MAWB Prefix',
  CustomerNoChinese: 'Код клиента + китайский',
  SupplierNoChinese: 'Код поставщика + китайский',
  pageDisplay: 'Отображение страницы',
  required: 'Обязательно ли',
  b2bWebsite: 'B2B-сайт',
  b2bWebsiteDisplay: 'Отображение B2B-сайта'
}
